// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PositionIdColumn.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import RelationshipColumn from './Izenda.RelationshipColumn';
import Validator from 'share/components/hoc/Izenda.Validator';
import NumericInput from 'share/components/controls/Izenda.NumericInput';
import constants from 'logic/data/Izenda.RelationshipConstants';
// $FlowFixMe
import { isNil } from 'lodash/fp';

const ValidateInput = Validator()(NumericInput);

export default function PositionIdInput(relationshipItem: any): any {
  const relationshipVM = this.props.store;
  // Only allow number in positionId input
  const pattern = constants.POSITION_ID.PATTERN;
  const options = {
    isDecimal: false,
    format: constants.POSITION_ID.FORMAT
  };

  function updateValue(e: number): void {
    if ((pattern).test(e) || isNil(e)) {
      return relationshipItem.setPositionId(e);
    }
    if (e === 0) {
      relationshipItem.setPositionId(null);
    }
  }

  return (
    <RelationshipColumn
      classes='form-control u_overflowHidden'
      relationshipItem={relationshipItem}
      store={relationshipVM}
      fieldCheck={'positionId'}
      setFunction={updateValue}
      selectedFunction={relationshipItem.positionId}
      rowIndex={relationshipItem.position}
      component={ValidateInput}
      componentOptions={options}
      validationsRules={''}
    />
  );
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DataModel/Relationship/Izenda.PositionIdColumn.js